import { ContentOpinionType, IArea, ITheme, ISearchResult } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const ContentService = {
    async getAllArea(): Promise<IArea[]> {
        const response = await fetch('/Api/Content/GetAllArea', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },
    async getAllTheme(): Promise<ITheme[]> {
        const response = await fetch('/Api/Content/GetAllTheme', {
            method: 'GET',
            headers,
        });
        return await response.json();
    },
    async addHit(contentId: number) {
        await fetch('/Api/Content/AddHit?contentId=' + contentId, {
            method: 'POST',
            headers,
        });
    },
    async search(
        searchString: string,
        currentAreaId: number,
        areaId: number | null,
        pageNumber: number,
        signal?: AbortSignal
    ): Promise<ISearchResult> {
        const response = await fetch('/Api/Content/Search', {
            method: 'POST',
            body: JSON.stringify({
                pageNumber,
                searchString,
                currentAreaId,
                areaId,
            }),
            headers,
            signal,
        });
        return await response.json();
    },
    async setOpinion(contentId: number, opinion: ContentOpinionType) {
        await fetch('/Api/Content/AddOpinion', {
            method: 'POST',
            body: JSON.stringify({
                contentId: contentId,
                opinion: opinion,
            }),
            headers,
        });
    },
    async sendComment(contentId: number, comment: string, link: string) {
        const response = await fetch('/Api/Content/AddComment', {
            method: 'POST',
            body: JSON.stringify({
                contentId: contentId,
                comment: comment,
                link: link,
            }),
            headers,
        });
        return response;
    },
};
